/**
 * 変更破棄確認モーダル (design L855-870。共通仕様 demand-forecast-common.md
 * AC-DFC-EDIT-002)。
 *
 * 48コマ表の「変更を破棄」ボタン押下時に表示する破壊操作の確認ダイアログ。
 * 確定すると編集中 (未保存) の値を破棄し、直近の保存済み状態に戻す。
 *
 * (旧 ResetConfirmModal。demand-fix-edit-operation で discard* 系へ全面 rename —
 * spec AC-DFC-EDIT-002「ボタン名称は『変更を破棄』に統一する」と識別子を一致させ、
 * 旧 reset〈取込原値固定復元〉セマンティクスとの誤読リスクを除くため。)
 */
import { useTranslation } from 'react-i18next'

import {
  DangerButton,
  HStack,
  TertiaryButton,
  Text,
} from '@enechain/ecloud-designsystem'

import { Modal } from '~/components/common/Modal'

type Props = {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
}

export const DiscardConfirmModal = ({
  isOpen,
  onConfirm,
  onCancel,
}: Props): React.ReactElement => {
  const { t } = useTranslation()

  const footer = (
    <HStack gap={3}>
      <TertiaryButton onClick={onCancel}>
        {t('common:action.cancel')}
      </TertiaryButton>
      <DangerButton onClick={onConfirm}>
        {t('page:demandForecastDaily.koma.discardConfirmButton')}
      </DangerButton>
    </HStack>
  )

  return (
    <Modal
      footer={footer}
      isOpen={isOpen}
      onClose={onCancel}
      // 幅は UI 辞書 components.md `.ecl-modal` の 4 段 (既定 md)。 8080 `#dft-reset-modal` は既定幅の `ecl-modal`
      size="md"
      title={t('page:demandForecastDaily.koma.discardConfirmTitle')}
    >
      <Text>{t('page:demandForecastDaily.koma.discardConfirmBody')}</Text>
    </Modal>
  )
}
